module.exports = "<!--The content below is only a placeholder and can be replaced.-->\r\n<router-outlet></router-outlet>\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// /Users/ken/Dev/workspace/snowmantech/naturallyplus/web-cms/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main